import React from 'react';
import { Shield, Users, Target, Lightbulb } from 'lucide-react';

export const About = () => {
  const values = [
    { icon: Shield, text: 'Field-tested solutions' },
    { icon: Users, text: 'Built by practitioners' },
    { icon: Target, text: 'Reality-engineered' },
    { icon: Lightbulb, text: 'Innovation-driven' },
  ];

  return (
    <section id="about" className="py-24 bg-[#1A2733] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
              ABOUT <span className="text-[#30D5C8]">US</span>
            </h2>
          </div>

          <div className="bg-[#0D1115]/80 backdrop-blur-sm border border-[#506273]/30 rounded-2xl p-8 sm:p-12">
            <div className="space-y-6 text-center">
              <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] leading-relaxed">
                Project Flow Automations was built by people who have lived the field pain:
              </p>
              <div className="grid grid-cols-2 gap-4 py-6">
                <div className="text-[#F5F7F8] font-['Montserrat'] font-semibold">
                  Late reports
                </div>
                <div className="text-[#F5F7F8] font-['Montserrat'] font-semibold">
                  Bad data
                </div>
                <div className="text-[#F5F7F8] font-['Montserrat'] font-semibold">
                  Spreadsheet dependency
                </div>
                <div className="text-[#F5F7F8] font-['Montserrat'] font-semibold">
                  Misaligned cost/schedule
                </div>
              </div>
              <p className="text-[#30D5C8] text-xl sm:text-2xl font-['Montserrat'] font-bold pt-4">
                Our mission: eliminate all of that with automation engineered for reality — not theory.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-12">
            {values.map((value, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center space-y-3 p-4 bg-[#0D1115]/50 backdrop-blur-sm rounded-lg hover:bg-[#0D1115]/80 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-[#30D5C8]/10 rounded-lg flex items-center justify-center">
                  <value.icon className="text-[#30D5C8]" size={24} />
                </div>
                <p className="text-[#CBD3D9] font-['Open_Sans'] text-sm">
                  {value.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};